export default __webpack_public_path__ + "static/media/webbing.bcba018a.png";